/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Status_ConceptInputs */

const en_project_status_concept = /** @type {(inputs: Project_Status_ConceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design concept`)
};

const lv_project_status_concept = /** @type {(inputs: Project_Status_ConceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dizaina koncepts`)
};

/**
* | output |
* | --- |
* | "Design concept" |
*
* @param {Project_Status_ConceptInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_status_concept = /** @type {((inputs?: Project_Status_ConceptInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Status_ConceptInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_status_concept(inputs)
	return en_project_status_concept(inputs)
});